import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CoimepPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    igreja: '',
    cargo: '',
    cidade: '',
    pais: '',
    mensagem: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formDataToSend = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/coimep-inscricao', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend,
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          email: '',
          telefone: '',
          igreja: '',
          cargo: '',
          cidade: '',
          pais: '',
          mensagem: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const whatsappNumber = '+351912735202';
  const whatsappMessage = 'Olá Pastor Emerson Souza! Gostaria de saber mais sobre a filiação à COIMEP.';
  const whatsappUrl = `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(whatsappMessage)}`;

  const googleFormUrl = 'https://forms.gle/KMuk8a6qUkaWwkVM9';

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-400 via-purple-500 to-pink-500">
      {/* Header */}
      <header className="bg-white/98 backdrop-blur-lg shadow-2xl border-b-4 border-gradient-to-r from-indigo-600 to-purple-600">
        <div className="px-8 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-8">
              <img
                src="https://static.readdy.ai/image/8fbfc975813ef59021c9f16b313e86f9/f5810bc36c96b4c4a03e9a9aa341e507.png"
                alt="Assembleia de Deus - Missão Europa"
                className="w-16 h-16 object-contain shadow-2xl rounded-2xl border-4 border-indigo-200 hover:scale-105 transition-transform duration-300"
              />
              <div className="text-center flex-1">
                <h1 className="text-3xl font-bold bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent whitespace-nowrap">
                  <span style={{ fontFamily: '"Agnes", serif' }}>IGREJA AD MISSÃO EUROPA CHURCH</span>
                </h1>
                <p className="text-lg text-gray-700 font-semibold">Church Portugal • COIMEP • Convenção Internacional</p>
              </div>
            </div>
            
            <nav className="flex items-center space-x-6">
              <button 
                onClick={() => navigate('/home')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-home-line"></i>
                <span>Início</span>
              </button>
              <button 
                onClick={() => navigate('/coimep')}
                className="flex items-center space-x-2 px-4 py-2 text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-building-line"></i>
                <span>COIMEP</span>
              </button>
              <button 
                onClick={() => navigate('/bible')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-book-line"></i>
                <span>Bíblia</span>
              </button>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <div className="relative h-96 bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 overflow-hidden">
        <div className="absolute inset-0 bg-black/30"></div>
        <img 
          src="https://public.readdy.ai/ai/img_res/510141e42e63d9cae8e16bf7048aa104.jpg"
          alt="COIMEP - Convenção Internacional"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white max-w-4xl px-6">
            <h2 className="text-5xl font-bold mb-4">COIMEP</h2>
            <p className="text-xl mb-4 opacity-90">
              Convenção Internacional de Igrejas e Ministros de Culto da Europa
            </p>
            <p className="text-lg mb-8 opacity-85">
              "Unindo ministérios, edificando o Reino de Deus" - Fundada em 2021
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href={googleFormUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                Inscrever-se na COIMEP
              </a>
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-green-700 transition-colors border-2 border-white whitespace-nowrap cursor-pointer"
              >
                Falar com Pastor Emerson
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        {/* Apresentação Institucional */}
        <div className="text-center mb-12">
          <h3 className="text-3xl font-bold text-white mb-4">Apresentação Institucional</h3>
          <p className="text-xl text-white/90">Conhecendo a COIMEP</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {/* About COIMEP */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8 border border-white/20">
            <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-building-line text-3xl text-white"></i>
            </div>
            <h4 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-4 text-center">Nossa História</h4>
            <p className="text-gray-700 leading-relaxed mb-4">
              A COIMEP foi fundada no ano de 2021, em Portugal, com o propósito de unir igrejas, pastores, obreiros e ministros que servem a Deus com integridade, amor e fidelidade ao Evangelho de Cristo.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Hoje, a COIMEP possui sedes ativas em Portugal, Itália e Brasil, sustentada pelos colaboradores e ministérios filiados que, pela fé, mantêm viva a obra de Deus em diversos países.
            </p>
          </div>

          {/* Mission */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8 border border-white/20">
            <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-heart-line text-3xl text-white"></i>
            </div>
            <h4 className="text-xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-4 text-center">Nossa Missão</h4>
            <p className="text-gray-700 leading-relaxed mb-4">
              A convenção tem como missão fortalecer o corpo de Cristo, promover a comunhão entre os ministérios e garantir que cada igreja filiada caminhe em unidade doutrinária, ética e espiritual.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Conforme os princípios estabelecidos em nosso Estatuto, buscamos a excelência no serviço ao Senhor.
            </p>
          </div>
        </div>

        {/* Contact and Registration Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {/* Registration Form */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8 border border-white/20">
            <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent text-center mb-8">
              Inscrição na COIMEP
            </h3>

            <div className="space-y-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-file-list-line text-3xl text-white"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-800 mb-4">Formulário Oficial</h4>
                <p className="text-gray-600 mb-6">
                  Preencha o formulário oficial da COIMEP para iniciar o processo de filiação da sua igreja ou ministério.
                </p>
                <a
                  href={googleFormUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 px-6 rounded-lg font-medium hover:from-blue-700 hover:to-purple-700 transition-colors flex items-center justify-center whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-external-link-line mr-2"></i>
                  Acessar Formulário Oficial
                </a>
              </div>

              <div className="border-t border-gray-200 pt-6">
                <h5 className="text-md font-semibold text-gray-800 mb-3">Requisitos para Filiação:</h5>
                <ul className="space-y-2 text-gray-600 text-sm">
                  <li className="flex items-start">
                    <i className="ri-check-line text-green-600 mr-2 mt-1 flex-shrink-0"></i>
                    <span>Estar em plena comunhão espiritual e doutrinária</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-green-600 mr-2 mt-1 flex-shrink-0"></i>
                    <span>Alinhamento ao Estatuto e princípios da Convenção</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-green-600 mr-2 mt-1 flex-shrink-0"></i>
                    <span>Compromisso com a unidade do Corpo de Cristo</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-green-600 mr-2 mt-1 flex-shrink-0"></i>
                    <span>Fidelidade ao Evangelho de Cristo</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8 border border-white/20">
            <h3 className="text-2xl font-bold bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent text-center mb-8">
              Contato Direto
            </h3>

            <div className="space-y-6">
              {/* Pastor Emerson Souza */}
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-r from-green-500 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-user-star-line text-3xl text-white"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-800 mb-2">Pastor Emerson Souza</h4>
                <p className="text-green-600 font-medium mb-4">Primeiro Secretário da Convenção</p>
                <p className="text-gray-600 mb-6 text-sm">
                  Entre em contato direto com o Primeiro Secretário para esclarecimentos sobre filiação e processos da COIMEP.
                </p>
              </div>

              {/* WhatsApp Contact */}
              <div className="bg-green-50 rounded-lg p-4">
                <h5 className="text-md font-semibold text-gray-800 mb-3 flex items-center">
                  <i className="ri-whatsapp-line text-green-600 mr-2"></i>
                  WhatsApp
                </h5>
                <p className="text-gray-600 text-sm mb-4">
                  Fale diretamente com Pastor Emerson Souza pelo WhatsApp para um atendimento personalizado.
                </p>
                <a
                  href={whatsappUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-green-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-green-700 transition-colors flex items-center justify-center whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-fill mr-2"></i>
                  Falar com Pastor Emerson
                </a>
                <p className="text-sm text-gray-500 mt-3 text-center font-mono">
                  {whatsappNumber}
                </p>
              </div>

              {/* Phone Contact */}
              <div className="bg-blue-50 rounded-lg p-4">
                <h5 className="text-md font-semibold text-gray-800 mb-3 flex items-center">
                  <i className="ri-phone-line text-blue-600 mr-2"></i>
                  Telefone
                </h5>
                <p className="text-gray-600 text-sm mb-4">
                  Ligue diretamente para o Primeiro Secretário da Convenção.
                </p>
                <a
                  href={`tel:${whatsappNumber}`}
                  className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-blue-700 transition-colors flex items-center justify-center whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-fill mr-2"></i>
                  Ligar Agora
                </a>
                <p className="text-sm text-gray-500 mt-3 text-center font-mono">
                  {whatsappNumber}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Biblical Verses Section */}
        <div className="bg-gradient-to-r from-blue-600/90 to-purple-600/90 backdrop-blur-sm rounded-2xl p-8 mb-16 text-white">
          <h4 className="text-2xl font-bold text-center mb-8">Versículos que nos Inspiram</h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <p className="text-lg mb-2">"E tudo quanto fizerdes, fazei-o de todo o coração, como ao Senhor, e não aos homens."</p>
              <p className="text-sm opacity-90">Colossenses 3:23</p>
            </div>
            <div className="text-center">
              <p className="text-lg mb-2">"Ora, há diversidade de dons, mas o Espírito é o mesmo."</p>
              <p className="text-sm opacity-90">1 Coríntios 12:4</p>
            </div>
            <div className="text-center">
              <p className="text-lg mb-2">"Andarão dois juntos, se não estiverem de acordo?"</p>
              <p className="text-sm opacity-90">Amós 3:3</p>
            </div>
          </div>
        </div>

        {/* Leadership Section */}
        <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8 mb-16 border border-white/20">
          <h4 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent text-center mb-8">Liderança da COIMEP</h4>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Pastor Presidente */}
            <div className="text-center">
              <div className="w-24 h-24 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-star-line text-4xl text-white"></i>
              </div>
              <h5 className="text-xl font-bold text-gray-800 mb-2">Pastor Adauto Pinheiro</h5>
              <p className="text-purple-600 font-medium mb-4">Pastor Presidente em Portugal</p>
              <p className="text-gray-700 text-sm">
                Líder dedicado que conduz a COIMEP com sabedoria e amor, promovendo a unidade entre os ministérios.
              </p>
            </div>

            {/* Primeiro Secretário */}
            <div className="text-center">
              <div className="w-24 h-24 bg-gradient-to-r from-green-500 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-settings-line text-4xl text-white"></i>
              </div>
              <h5 className="text-xl font-bold text-gray-800 mb-2">Pastor Emerson Souza</h5>
              <p className="text-green-600 font-medium mb-4">Primeiro Secretário da Convenção</p>
              <p className="text-gray-700 text-sm">
                Responsável pelos processos de filiação e comunicação oficial da COIMEP.
              </p>
            </div>
          </div>
        </div>

        {/* Message to Ministers */}
        <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8 border border-white/20">
          <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent text-center mb-8">
            Mensagem aos Pastores, Obreiros e Membros
          </h3>
          <div className="text-gray-700 leading-relaxed space-y-4">
            <p className="text-center text-lg">
              Amados servos e servas do Senhor, graça e paz vos sejam multiplicadas!
            </p>
            <p>
              Vivemos tempos em que a fidelidade ao chamado de Deus é mais necessária do que nunca. O Senhor tem levantado homens e mulheres dispostos a servir com amor e dedicação, e é por meio de cada um de vocês que a obra de Deus avança nas nações.
            </p>
            <p>
              A COIMEP reconhece o valor de cada ministério e de cada servo que dedica sua vida à pregação do Evangelho. Unidos em fé, seguimos construindo uma obra sólida, pautada na verdade e na santidade da Palavra de Deus.
            </p>
            <div className="text-center mt-8">
              <p className="text-blue-600 font-semibold italic text-lg">
                "Sede firmes e constantes, sempre abundantes na obra do Senhor, sabendo que o vosso trabalho não é vão no Senhor."
              </p>
              <p className="text-gray-600 mt-2">1 Coríntios 15:58</p>
            </div>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="bg-gradient-to-r from-blue-600/90 to-purple-600/90 backdrop-blur-sm py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center text-white">
            <div>
              <div className="text-4xl font-bold mb-2">2021</div>
              <div className="text-lg opacity-90">Ano de Fundação</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">3</div>
              <div className="text-lg opacity-90">Países (PT • IT • BR)</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">∞</div>
              <div className="text-lg opacity-90">Ministérios Unidos</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">24/7</div>
              <div className="text-lg opacity-90">Comunhão Espiritual</div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900/95 backdrop-blur-sm text-white py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center">
                  <i className="ri-building-line text-white text-xl"></i>
                </div>
                <h4 className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                  COIMEP
                </h4>
              </div>
              <p className="text-gray-300 mb-2">
                Convenção Internacional de Igrejas e Ministros de Culto da Europa
              </p>
              <p className="text-gray-300 text-sm">
                Fundada em 2021 | Sedes: Portugal • Itália • Brasil
              </p>
              <p className="text-blue-400 text-sm mt-2 font-semibold">
                "Unindo ministérios, edificando o Reino de Deus"
              </p>
            </div>

            <div>
              <h5 className="text-lg font-semibold mb-4">Liderança</h5>
              <div className="text-gray-300 space-y-2">
                <p><strong>Pastor Adauto Pinheiro</strong></p>
                <p className="text-sm">Pastor Presidente em Portugal</p>
                <p className="mt-3"><strong>Pastor Emerson Souza</strong></p>
                <p className="text-sm">Primeiro Secretário da Convenção</p>
                <p className="text-sm mt-2">{whatsappNumber}</p>
              </div>
            </div>

            <div>
              <h5 className="text-lg font-semibold mb-4">Contato</h5>
              <div className="space-y-3">
                <a
                  href={whatsappUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-whatsapp-fill text-green-500"></i>
                  <span>WhatsApp</span>
                </a>
                <a
                  href={`tel:${whatsappNumber}`}
                  className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-phone-fill text-blue-500"></i>
                  <span>Telefone</span>
                </a>
                <a
                  href={googleFormUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-file-list-fill text-purple-500"></i>
                  <span>Formulário de Inscrição</span>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-300">
            <p>&copy; 2024 COIMEP - Convenção Internacional de Igrejas e Ministros de Culto da Europa. Todos os direitos reservados.</p>
            <p className="mt-2">
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}